export const getQueryParamKeyFromDataKey = dataKey => dataKey && dataKey.toLowerCase() || '';